import { render, staticRenderFns } from "./BtnBuildCorreos.vue?vue&type=template&id=67709dd0&scoped=true"
import script from "./BtnBuildCorreos.vue?vue&type=script&lang=js"
export * from "./BtnBuildCorreos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67709dd0",
  null
  
)

export default component.exports